import type { PmsCapability, PmsGate, PmsLocation } from 'app/types/pms'

export const PMS_CAPABILITY_FIELDS = `pmsIntegrated kollaConsumerId`

const isKolla = (location: PmsLocation) => !!location.pmsIntegrated && !!location.kollaConsumerId

// All four read data only Kolla syncs: treatment status is computed for Kolla patients alone, room
// schedules and comm logs come only from Kolla, and in-app booking runs the Kolla scheduler flow.
export const PMS_SUPPORT: Readonly<Record<PmsCapability, (location: PmsLocation) => boolean>> = {
  unscheduledTreatment: isKolla,
  scheduleBoard: isKolla,
  inAppBooking: isKolla,
  commLog: isKolla,
}

export function pmsGate(locations: PmsLocation[], capability: PmsCapability): PmsGate {
  if (!locations.some((location) => location.pmsIntegrated)) return `padlock`
  const supported = locations.filter(PMS_SUPPORT[capability]).length
  if (supported === 0) return `hidden`
  return supported === locations.length ? `available` : `partial`
}
